module.exports = __webpack_public_path__ + "static/media/desktop.44afeab.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/GulpOfWater/desktop.mp4
// module id = M7pc
// module chunks = 1